export default class ObjectHelper {
    static getObjectKeysIfValueIsTrue(data) {
        let ids = []

        new Map(Object.entries(data))
            .forEach((isSelected, formId) => isSelected ? ids.push(Number(formId)) : null)

        return ids
    }
}

